import
  React, {
  useContext
} from 'react';

import {
  HandleRender,
  withScreenViewTagging
} from 'hocs';

import {
  getStorageWithExpiry
} from 'helpers';

import {
  AppContext
} from 'context';

import {
  ErrorKeys
} from '../../../../constants';

import {
  PurchaseCard
} from '../components';

import {
  useVoucherHistory
} from '../hooks';

const PastPurchasesUI = () => {

  const voucherHistory = useVoucherHistory(true);
  const { config } = useContext(AppContext);

  const getPastPurchasesState = () => {

    if (voucherHistory?.isError) {

      return {
        ...voucherHistory,
        isError: true,
        error: {
          type: ErrorKeys.TextOnly,
          title: config?.voucherAdvanceConfig?.purchaseHistoryError
        }
      };
    }

    if (voucherHistory?.content?.length === 0) {

      return {
        ...voucherHistory,
        isError: true,
        error: {
          type: ErrorKeys.TextOnly,
          title: config?.voucherAdvanceConfig?.noPastPurchases
        }
      };
    }

    return voucherHistory;

  };

  const state = getPastPurchasesState();

  return (

    <HandleRender
      isLoading={voucherHistory?.isLoading}
      isError={state?.isError}
      error={state?.error}>

      {
        state?.content?.map((purchase, i) =>
          <PurchaseCard
            key={`purchase-card-${i}`}
            margin={'8px 0'}
            {...purchase} />
        )
      }
    </HandleRender>
  );
};

PastPurchasesUI.pageName = 'cbu: connectu: voucher advance: past purchases';

PastPurchasesUI.tagViewData = {
  page_section: 'voucher advance',
  visitor_customer_segment: getStorageWithExpiry('msisdn', 'msisdnType', ''),
  visitor_type: 'consumer',
  visitor_id_asset_active: getStorageWithExpiry('msisdn', 'hashedMsisdn', '')
};

export const PastPurchases = withScreenViewTagging(PastPurchasesUI);